import { AmberHoc, AmberHocProps } from '../../../util';
import {
  DeleteGrainBinSiteMutationVariables as Variables,
  GrainBinSiteFragmentFragment as Result,
  withDeleteGrainBinSite as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

export type WithDeleteGrainBinSiteHocChildProps = {
  deleteGrainBinSite: (variables: Variables) => Promise<Result | null>;
};

export const withDeleteGrainBinSiteHoc: AmberHoc<{}, WithDeleteGrainBinSiteHocChildProps> = (
  component
) =>
  HOC<
    AmberHocProps<{}, WithDeleteGrainBinSiteHocChildProps, typeof component>,
    WithDeleteGrainBinSiteHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        deleteGrainBinSite: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected UI error');
          }
          const result = await mutate({
            variables,
            update: (proxy, { data, errors }) => {
              if (errors || !data) {
                return;
              }
            },
          });
          if (!result) {
            throw new Error('Unexpected server response');
          }
          const { data, errors } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data) {
            throw new Error('Unexpected server response');
          }
          return data.deleteGrainBinSite;
        },
      };
    },
  })(component as any);
